import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchVehicles } from "../actions/VehicleActions";

export const useVehicles = () => {
  const dispatch = useDispatch();
  const vehicles = useSelector((state) => state.vehicle.items);
  const loading = useSelector((state) => state.vehicle.loading);
  const error = useSelector((state) => state.vehicle.error);

  const loadVehicles = useCallback(() => {
    return dispatch(fetchVehicles());
  }, [dispatch]);

  return {
    vehicles,
    loading,
    error,
    loadVehicles,
  };
};

